import { render, staticRenderFns } from "./copertoplufatura.vue?vue&type=template&id=29f20c78&"
import script from "./copertoplufatura.vue?vue&type=script&lang=js&"
export * from "./copertoplufatura.vue?vue&type=script&lang=js&"
import style0 from "./copertoplufatura.vue?vue&type=style&index=0&id=29f20c78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports